exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".timeline .slider{position:absolute;border:1px solid #000}.timeline .flag-slider{position:absolute}.timeline .flag-slider .flag{bottom:-4px;width:0}.timeline .handle{position:absolute;width:0}.timeline .handle-0 div{position:absolute;left:-11px;top:-1px}.timeline .handle-0 .frame-counter{position:absolute;top:8px;left:22px;font-size:12px}.timeline .handle-1 div{position:absolute;left:-5px;bottom:-6px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/autoprefixer-loader!./~/less-loader!./editor/styles/Timeline.less
// module id = 751
// module chunks = 0